import { Backdrop, Button, Grid, styled, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useEditStatusKandidat } from "../../../../api/effects/mutations/Kandidat/editKandidatStatus";
import { useFetchKandidat } from "../../../../api/effects/mutations/Kandidat/useFetchKandidat";
import useFetchAllStatusKandidat from "../../../../api/effects/queries/Kandidat/useFetchAllStatusKandidat";
import InputSelect from "../../../../components/InputSelect";
import { StatusKandidatResponse } from "../../../../models/Kandidat";
import {
  convertDateTime,
  toIsoStringDateTime,
} from "../../../../utils/dateConvert";

const SquareGrid = styled(Grid)(({ theme }) => ({
  backgroundColor: "#FFF",
  height: "auto",
  boxShadow: "1px 1px 10px #888888",
  borderRadius: "10px",
  padding: "1%",
  width: "45%",
  [theme.breakpoints.down("md")]: {
    width: "60%",
  },
  [theme.breakpoints.down("sm")]: {
    width: "90%",
    padding: "10px",
  },
  margin: "1%",
}));

const FullButton = styled(Button)(({ theme }) => ({
  marginTop: "3vh",
  marginBottom: "1vh",
  width: "60%",
}));

const ScrollGrid = styled(Grid)(({ theme }) => ({
  overflow: "auto",
  maxHeight: "90vh",
}));

const TitleGrid = styled(Grid)(({ theme }) => ({
  paddingTop: "1vh",
  paddingLeft: "11%",
}));

type Props = {
  open: boolean;
  handleClose: () => void;
  ID?: number;
};

export default function StatusKandidatModal({
  ID = -1,
  open,
  handleClose,
}: Props) {
  const { data: allStatusKandidatData } = useFetchAllStatusKandidat();

  const [allStatusKandidatDataState, setAllStatusKandidatDataState] = useState<
    StatusKandidatResponse[]
  >([]);

  useEffect(() => {
    if (allStatusKandidatData !== undefined) {
      setAllStatusKandidatDataState(allStatusKandidatData);
    }
  }, [allStatusKandidatData]);

  const [tanggalInterview, setTanggalInterview] = useState(
    toIsoStringDateTime(Date.now())
  );
  const [status, setStatus] = useState("");
  const [kandidat, setKandidat] = useState("");
  const [job, setJob] = useState("");

  const { mutateAsync: GetKandidatData } = useFetchKandidat({
    onSuccess(data) {
      setStatus(data.STATUS_KANDIDAT_ID);
      if (data.TANGGAL_INTERVIEW) {
        setTanggalInterview(data.TANGGAL_INTERVIEW);
      }
      setKandidat(data.NAMA);
      setJob(data.JOB);
      console.log("Success");
    },
    onError() {
      console.log("Error");
    },
  });

  useEffect(() => {
    if (ID > 0) {
      GetKandidatData(ID);
    }
  }, [open]);

  const handleStatusKandidat = (e: any) => {
    setStatus(e.target.value);
  };

  const handleSave = () => {
    EditStatusKandidat({
      KANDIDAT_ID: ID,
      STATUS_KANDIDAT_ID: status,
    });
  };

  const { mutateAsync: EditStatusKandidat } = useEditStatusKandidat({
    onSuccess() {
      handleClose();
      console.log("Success");
    },
    onError() {
      console.log("Error");
    },
  });

  return (
    <Backdrop
      sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
      open={open}
    >
      <SquareGrid container>
        <ScrollGrid container>
          <Grid container justifyContent="flex-start" paddingLeft={"10.5%"} item xs={6}
            paddingBottom={
              {
                xs: 5,
                sm: 5,
                md: 5,
                lg: 5,
                xl: 5
              }}>
            <Typography variant="subtitle1" color="black">
              Edit Status Kandidat
            </Typography>
          </Grid>
          <TitleGrid container justifyContent="flex-end" item xs={6}>
            <Button onClick={handleClose}>Close</Button>
          </TitleGrid>
          <TitleGrid container item xs={12}>
            <Grid item xs={12}>
              <Typography color="black" variant="h6">
                Kandidat :
              </Typography>
            </Grid>
            <Grid item xs={12}>
              <Typography color="black">{kandidat}</Typography>
            </Grid>
          </TitleGrid>

          <TitleGrid container item xs={12}>
            <Grid item xs={12}>
              <Typography color="black" variant="h6">
                Job :
              </Typography>
            </Grid>
            <Grid item xs={12}>
              <Typography color="black">{job}</Typography>
            </Grid>
          </TitleGrid>
          <InputSelect
            title={"Status Kandidat"}
            value={status}
            selection={allStatusKandidatDataState}
            handleEdit={handleStatusKandidat}
          />
          <Grid container justifyContent="center" item xs={12}>
            <FullButton variant="contained" onClick={handleSave}>
              Save
            </FullButton>
          </Grid>
        </ScrollGrid>
      </SquareGrid>
    </Backdrop>
  );
}
